import { render, staticRenderFns } from "./ODateButton.vue?vue&type=template&id=6cb2dd3f&scoped=true&"
import script from "./ODateButton.vue?vue&type=script&lang=js&"
export * from "./ODateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2dd3f",
  null
  
)

export default component.exports